let lastTime = 0
let vendors = ['ms', 'moz', 'webkit', 'o']
let x

//on client side only
if (typeof window !== 'undefined') {
  let requestAnimationFrame = window['requestAnimationFrame']

  for (x = 0; x < vendors.length && !window['requestAnimationFrame']; ++x) {
    requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame']
  }

  if (!requestAnimationFrame) {
    window.requestAnimationFrame = function (callback) {
      var currTime = new Date().getTime(),
        timeToCall = Math.max(0, 16 - (currTime - lastTime)),
        id = window.setTimeout(function () {
          callback(currTime + timeToCall)
        }, timeToCall)

      lastTime = currTime + timeToCall

      return id
    }
  }
}
